/**
 * Custom event bindings.
 * ---------------------------------------------------------------------------
 * Click tracking:
 * Clicks on `.custom-event-click` read the element's data-* attributes and
 * pass them to window.NipheanTracking.track.
 */
(function (window, document) {
  'use strict';

  var CLICK_SELECTOR = '.custom-event-click';

  function dataKeyToParamKey(key) {
    return key.slice(5).replace(/-/g, '_');
  }

  function getDataParams(element) {
    var params = {};
    if (!element || !element.attributes) return params;

    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (attribute.name.indexOf('data-') !== 0) return;
      params[dataKeyToParamKey(attribute.name)] = attribute.value;
    });

    return params;
  }

  function normalizeParams(params) {
    if (!params) return {};

    if (params.page_type === undefined && params.pageType !== undefined) {
      params.page_type = params.pageType;
    }

    if (params.event_label === undefined && params.eventLabel !== undefined) {
      params.event_label = params.eventLabel;
    }

    if (params.page_path === undefined && params.pagePath !== undefined) {
      params.page_path = params.pagePath;
    }

    if (params.first_category === undefined && params.firstCategory !== undefined) {
      params.first_category = params.firstCategory;
    }

    if (params.segment_name === undefined && params.segmentName !== undefined) {
      params.segment_name = params.segmentName;
    }

    if (params.user_id === undefined && params.userId !== undefined) {
      params.user_id = params.userId;
    }

    delete params.pageType;
    delete params.eventLabel;
    delete params.pagePath;
    delete params.firstCategory;
    delete params.segmentName;
    delete params.userId;
    delete params.type;

    return params;
  }

  function trackClickElement(element) {
    var params = normalizeParams(getDataParams(element));
    if (!params.event) return null;

    if (window.NipheanTracking && typeof window.NipheanTracking.track === 'function') {
 
      return window.NipheanTracking.track(params);
    }

    return null;
  }

  function onDocumentClick(event) {
    var target = event.target.closest(CLICK_SELECTOR);
    if (!target) return;

    trackClickElement(target);
  }

  document.addEventListener('click', onDocumentClick);

  window.NipheanCustomEvent = window.NipheanCustomEvent || {};
  window.NipheanCustomEvent.trackClickElement = trackClickElement;
})(window, document);
